import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger, Checkbox } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import OperationTypeMasterModalPage from '../../../containers/masters/OperationType/OperationTypeMasterModalPage'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class OperationTypeMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        text: null,
        code: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchOperationTypesTable()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    const orderBy = this.props.filter.orderBy === `+${field}` ? `-${field}` : `+${field}`
    this.props.actions.fetchOperationTypesTable({ ...this.state.filter, ...this.props.filter, orderBy: orderBy })
  }

  handleCodeFilterChange (code) {
    this.setState({ filter: { ...this.state.filter, code } })
  }

  handleTextFilterChange (text) {
    this.setState({ filter: { ...this.state.filter, text } })
  }

  searchOperationTypes () {
    this.props.actions.fetchOperationTypesTable({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  recoverOperationType (operationTypeId) {
    this.props.actions.openModal('recoverOperationType', () => this.props.actions.recoverOperationType(operationTypeId))
  }

  resetFilters () {
    this.setState({
      filter: {
        text: null,
        code: null
      }
    }, () => { this.searchOperationTypes() })
  }

  render () {
    const {
      t, operationTypeList, pageSize, rowsCount, filter,
      filter: { page },
      actions: { fetchOperationTypesTable, openOperationTypeModal, deleteOperationType }
    } = this.props
    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'operationTypeMasterPage' })
    const tKey = 'MASTERS.OPERATION_TYPE_MASTER.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}RECOVER`)}</Tooltip>)
    const hasFilters = (this.state.filter.code || this.state.filter.text)
    return (
      <div id='operationTypeMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openOperationTypeModal()}>
              <i className='iDocIcon-add-plus'></i>{t(`${tKey}ADD`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="operationTypeCodeFilter"
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
                onInputChange={(value) => this.handleCodeFilterChange(value)}
              />
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="operationTypeTextFilter"
                controlLabel={t(`${tKey}TEXT`)}
                placeholder={t(`${tKey}TEXT`)}
                onInputChange={(value) => this.handleTextFilterChange(value)}
                maxLength= {50}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchOperationTypes()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {operationTypeList.length !== 0 &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('code') }}>
                        {t(`${tKey}CODE`)}
                        <i className={this.getSortIcon('code')} />
                      </th>
                      <th onClick={() => { this.changeOrder('name') }}>
                        {t(`${tKey}NAME`)}
                        <i className={this.getSortIcon('name')} />
                      </th>
                      <th onClick={() => { this.changeOrder('description') }}>
                        {t(`${tKey}DESCRIPTION`)}
                        <i className={this.getSortIcon('description')} />
                      </th>
                      <th className='actions' onClick={() => { this.changeOrder('isFleet') }}>
                        {t(`${tKey}IS_FLEET`)}
                        <i className={this.getSortIcon('isFleet')} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {operationTypeList && operationTypeList.map((operationType, idx) => {
                      return (
                        <tr key={idx} className={operationType.isDeleted ? 'is-deleted' : ''}>
                          <td>{operationType.code}</td>
                          <td>{operationType.operationTypeLocales && operationType.operationTypeLocales.length > 0 ? operationType.operationTypeLocales[0].name : ''}</td>
                          <td>{operationType.operationTypeLocales && operationType.operationTypeLocales.length > 0 ? operationType.operationTypeLocales[0].description : ''}</td>
                          <td className='actions'><span><Checkbox className="checkbox-no-label" checked={operationType.isFleet} disabled inline /></span></td>
                          <td className='actions'>
                            {!operationType.isDeleted ? (
                              <div>
                                <OverlayTrigger placement="left" overlay={editTooltip}>
                                  <a className='_Btn accept stk o-icn ' onClick={() => openOperationTypeModal(operationType.operationTypeId)}>
                                    <i className="iDocIcon-edit" />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' onClick={() => deleteOperationType(operationType.operationTypeId)}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                              </div>
                            ) : (
                              <div>
                                <OverlayTrigger placement="left" overlay={recoverTooltip}>
                                  <a className='_Btn accent stk o-icn ' onClick={() => this.recoverOperationType(operationType.operationTypeId)}>
                                    <i className='iDocIcon-undo-back' />
                                  </a>
                                </OverlayTrigger>
                              </div>
                            )}
                          </td>
                        </tr>)
                    })}
                  </tbody>
                </Table>
              }
              {(operationTypeList === null || operationTypeList === undefined || operationTypeList.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pageSize={pageSize}
                    totalRows={rowsCount}
                    onSelectAction={(value) => fetchOperationTypesTable({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <OperationTypeMasterModalPage />
      </div>
    )
  }
}

export default reduxForm({
  form: 'operationTypeMaster'
})(OperationTypeMaster)
